var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.47 23.75C18.76 23.75 18.04 23.49 17.49 22.96C15.65 21.21 14.91 19.3 15.34 17.43C15.85 15.23 17.78 14.25 19.47 14.25C21.16 14.25 23.1 15.24 23.6 17.43C24.03 19.3 23.28 21.21 21.45 22.96C20.9 23.49 20.19 23.75 19.47 23.75ZM16.8 17.77C16.42 19.44 17.53 20.92 18.53 21.87C19.06 22.38 19.89 22.37 20.42 21.87C21.42 20.92 22.53 19.44 22.14 17.76C21.8 16.28 20.49 15.75 19.48 15.75C18.46 15.75 17.15 16.28 16.8 17.77Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.51 19.2C18.96 19.2 18.51 18.75 18.51 18.2C18.51 17.65 18.95 17.2 19.51 17.2H19.52C20.07 17.2 20.52 17.65 20.52 18.2C20.52 18.75 20.07 19.2 19.51 19.2Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.49 35.75C31.78 35.75 31.06 35.49 30.5 34.96C28.65 33.21 27.9 31.3 28.34 29.42C28.85 27.23 30.79 26.24 32.49 26.24C34.19 26.24 36.13 27.23 36.64 29.42C37.07 31.29 36.32 33.21 34.47 34.95C33.92 35.49 33.21 35.75 32.49 35.75ZM32.49 27.75C31.47 27.75 30.15 28.28 29.8 29.77C29.41 31.44 30.53 32.93 31.53 33.88C32.06 34.39 32.9 34.39 33.44 33.88C34.44 32.93 35.56 31.45 35.17 29.78C34.84 28.28 33.52 27.75 32.49 27.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.53 31.2C31.98 31.2 31.53 30.75 31.53 30.2C31.53 29.65 31.97 29.2 32.53 29.2H32.54C33.09 29.2 33.54 29.65 33.54 30.2C33.54 30.75 33.08 31.2 32.53 31.2Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 32.75H23.3199C22.1599 32.75 21.1499 32.05 20.7499 30.97C20.3399 29.89 20.6399 28.7 21.5099 27.93L29.4999 20.94C29.9799 20.52 29.9899 19.95 29.8499 19.56C29.6999 19.17 29.3199 18.75 28.6799 18.75H25.9999C25.5899 18.75 25.2499 18.41 25.2499 18C25.2499 17.59 25.5899 17.25 25.9999 17.25H28.6799C29.8399 17.25 30.8499 17.95 31.2499 19.03C31.6599 20.11 31.3599 21.3 30.4899 22.07L22.4999 29.06C22.0199 29.48 22.0099 30.05 22.1499 30.44C22.2999 30.83 22.6799 31.25 23.3199 31.25H25.9999C26.4099 31.25 26.7499 31.59 26.7499 32C26.7499 32.41 26.4099 32.75 25.9999 32.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 32.75H23.3199C22.1599 32.75 21.1499 32.05 20.7499 30.97C20.3399 29.89 20.6399 28.7 21.5099 27.93L29.4999 20.94C29.9799 20.52 29.9899 19.95 29.8499 19.56C29.6999 19.17 29.3199 18.75 28.6799 18.75H25.9999C25.5899 18.75 25.2499 18.41 25.2499 18C25.2499 17.59 25.5899 17.25 25.9999 17.25H28.6799C29.8399 17.25 30.8499 17.95 31.2499 19.03C31.6599 20.11 31.3599 21.3 30.4899 22.07L22.4999 29.06C22.0199 29.48 22.0099 30.05 22.1499 30.44C22.2999 30.83 22.6799 31.25 23.3199 31.25H25.9999C26.4099 31.25 26.7499 31.59 26.7499 32C26.7499 32.41 26.4099 32.75 25.9999 32.75Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_454",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_454",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpanding);
export default __webpack_public_path__ + "static/media/expanding.d895ad8209edf961155fbf9be8e28e42.svg";
export { ForwardRef as ReactComponent };